export default {
  SET_SERVICE_TYPES_DATA(state, data) {
    state.serviceTypes = data;
  },
};
